module.exports = __webpack_public_path__ + "static/media/04.f4f8b228.png";